<template>
  <v-dialog
    v-model="bulkDevicesDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="bulkDevicesDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>הוספת מכשירים</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="sending"
          :disabled="sending"
          @click="send"
        >
          ביצוע
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-textarea
          name="imeiList"
          label="מכשירים להוספה"
          value=""
          v-model="imeiList"
          rows="5"
          hint="יש להזין רשימה של מספרי IMEI, כל אחד בשורה נפרדת או מופרדים בפסיקים"
        ></v-textarea>
        <v-select
          :items="deviceTypes"
          item-value="_id"
          item-text="title"
          label="סוג מכשיר"
          v-model="deviceType"
        ></v-select>
        <v-select
          :items="stores"
          item-value="_id"
          item-text="title"
          label="חנות"
          v-model="store"
        ></v-select>
        <v-select
          :items="storeBoxTypes"
          item-value="_id"
          item-text="title"
          label="מגירה"
          v-model="boxType"
        ></v-select>
        <v-text-field type="date" label="תאריך רכישה" v-model="purchaseDate" />
        <v-text-field label="מספר חשבונית" v-model="invoiceId" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      sending: false,
      imeiList: "",
      store: null,
      boxType: null,
      deviceType: null,
      purchaseDate: null,
      invoiceId: null
    };
  },

  computed: {
    bulkDevicesDialog: {
      get() {
        return this.$store.state.bulkDevicesDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_BULK_DEVICES_DIALOG", isActive);
      }
    },
    stores() {
      return this.$store.getters["entityList"]("stores");
    },
    storeBoxTypes() {
      if (this.store) {
        let store = this.$store.state.entities.stores[this.store];
        if (store) {
          let boxTypes = store.boxTypes;
          if (boxTypes) {
            return boxTypes
              .map(item => {
                return this.$store.state.entities.boxTypes[item];
              })
              .filter(item => {
                return !!item;
              });
          }
        }
      }
      return [];
    },
    deviceTypes() {
      return this.$store.getters["entityList"]("deviceTypes");
    }
  },

  methods: {
    send() {
      this.sending = true;

      getApi()
        .then(api => {
          let params = {
            imeiList: this.imeiList,
            store: this.store,
            boxType: this.boxType,
            deviceType: this.deviceType,
            purchaseDate: this.purchaseDate,
            invoiceId: this.invoiceId
          };
          return api.post("/devices/bulk-create", params);
        })
        .then(() => {
          this.bulkDevicesDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "מכשירים התווספו בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  },

  props: [],

  mixins: [Mixins],

  watch: {
    bulkDevicesDialog: {
      handler: function() {
        this.imeiList = "";
        this.store = null;
        this.boxType = null;
        this.deviceType = null;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
